import { RootPage } from '../page';
import $api from '../../api';
import CreateChannel from './createChannel';
import { ChangelogModel, ChangelogsConfig } from '../../models/Gen/BaseModels';
import cme from '../../models/ChangelogModelTrackableExtended';
import { displayTypeToName } from './utils';

class AnnouncementsOverviewView extends RootPage {
    constructor() {
        super();
        cme();

        const getProperFirstChannel = () => {
            //this.channels()[0].id
            const lastSaved = parseInt(localStorage.getItem('last_selected_channel_announcements'));

            if (this.channels().some(i => ko.unwrap(i.id) == lastSaved)) {
                return lastSaved;
            } else if (this.channels().filter(i => i.displayType == 1)[0]) {
                return this.channels().filter(i => i.displayType == 1)[0].id;
            } else {
                return -1;
            }
        }

        this.displayTypeToName = displayTypeToName;
        this.channels = ko.observableArray(this.getServerSideData('channels').items);
        this.announcements = ko.observableArray([]);
        this.selectedChannelId = ko.observable(getProperFirstChannel());

        //const announcementsData = this.getServerSideData('announcements');
        //if (announcementsData && announcementsData.length) {
        //    for (const data of announcementsData) {
        //        this.announcements.push(new ChangelogModel(data));
        //    }
        //}

        this.newAnnouncementMockDisplayed = ko.observable(true);
        this.hasAnnouncements = ko.computed(() => {
            return this.announcements().length > 0;
        });

        this.wizardMode = ko.observable(false);
        this.wizardStep = ko.observable(0);
        this.wizardData = ko.observable({});
        this.wizardSelectedChannel = ko.observable();

        this.wizardSelectedChannels = ko.computed(() => {
            const dt = ko.unwrap(this.wizardData()['displayType']);
            const channels = this.channelsByType(dt);
            if (channels.length > 0) {
                this.wizardSelectedChannel(channels[0].id)
            }
            return channels;
        });

        this.selectedChannelName = ko.computed(() => {
            const selChannel = this.channels().filter(i => i.id == this.selectedChannelId())[0];

            return selChannel ? ko.unwrap(selChannel.name) : '-';
        });
    }

    channelsByType(type) {
        return ko.unwrap(this.channels).filter(c => c.displayType == type);
    }

    get modalChannels() {
        return ko.unwrap(this.channels).filter(c => c.displayType == 1);
    }

    get toastChannels() {
        return ko.unwrap(this.channels).filter(c => c.displayType == 2);
    }

    get bannerChannels() {
        return ko.unwrap(this.channels).filter(c => c.displayType == 3);
    }

    getChannelById(id) {
        return this.channels().filter(i => i.id == id)[0];
    }

    onInit() {
        this.reloadAnnouncements();
    }

    createAnnouncement(channelId) {
        window.location.href = `/${window.auth.project.UniqueCode}/announcements/createdraft?channelId=${channelId}`
    }

    createAnnouncementWizard() {
        this.wizardMode(true);
        this.wizardData({});
        this.wizardStep(0);
    }

    wizardSelectItem(field, value, nextStep) {
        this.wizardData({ ...this.wizardData(), [field]: ko.observable(value) });
        this.wizardSetStep(nextStep);
    }

    wizardSetStep(step) {
        this.wizardStep(step);
        const el = document.getElementById('ws-' + this.wizardStep());

        el.scrollIntoView({
            behavior: "smooth",
        })
    }

    compareWizardData(field, cmp, value) {
        return ko.computed(() => {
            if (cmp == '=') {
                return ko.unwrap(this.wizardData()[field]) == value;
            } else if (cmp == 'set') {
                const t = typeof ko.unwrap(this.wizardData()[field]);

                return t != 'undefined' && ko.unwrap(this.wizardData()[field]) != null;
            } else {
                return false;
            }
        });
    }

    getWizardData(field) {
        return ko.unwrap(this.wizardData()[field]);
    }

    createChannel() {
        this.showDialog(CreateChannel(this));
    }

    selectChannel(id) {
        this.selectedChannelId(id);

        localStorage.setItem('last_selected_channel_announcements', id);

        this.reloadAnnouncements();
    }

    closeWizard() {
        this.wizardMode(false);
    }

    goToDetail(channel) {
        window.location.href = `/${window.auth.project.UniqueCode}/announcements/channeldetails/${channel.id}`;
    }

    setChangelogsFromPagedList(list) {
        var res = [];

        for (var i of list.items) {
            res.push(new ChangelogModel(i));
        }

        this.announcements(res);
        this.pageInfo = list;
    }

    edit(item) {
        const channel = this.getChannelById(ko.unwrap(item.channelId));
        window.location.href = `/${auth.project.UniqueCode}/announcements/${item.id()}`;
    }

    reloadAnnouncements() {
        $api.changelogs.getAll(
            { projectCode: window.auth.project.UniqueCode, page: 1, channelId: this.selectedChannelId() },
            {},
            (r) => {
                this.setChangelogsFromPagedList(r);
            }
        );
    }

    publish(item) {
        if (confirm('Do you really want to publish the announcement?')) {
            this.startSubmitting('publish');

            $api.changelogs.publish(
                { projectCode: auth.project.UniqueCode, id: ko.unwrap(item.id) },
                {},
                (resp) => {
                    TRACK_EVENT('Announcements', 'Published');

                    this.reloadAnnouncements();

                    this.showToast('Changelog published.');
                    this.stopSubmitting('publish');
                }
            );
        }
    }

    unpublish(item) {
        if (confirm('Do you really want to unpublish the announcement? Once published again, users will see it again.')) {
            this.startSubmitting('unpublish');

            $api.changelogs.unpublish(
                { projectCode: auth.project.UniqueCode, id: ko.unwrap(item.id) },
                {},
                (resp) => {
                    TRACK_EVENT('Announcements', 'Unpublished');
                    this.stopSubmitting('unpublish');
                    this.reloadAnnouncements();
                }
            );
        }
    }

    remove(item) {
        if (confirm('Really?')) {
            $api.changelogs.remove(
                { projectCode: window.auth.project.UniqueCode, id: ko.unwrap(item.id) },
                {},
                () => {
                    TRACK_EVENT('Announcements', 'Removed');
                    this.reloadAnnouncements();
                    this.showToast('The announcement was removed.');
                }
            );
        }
    }

    duplicate(item) {
        $api.changelogs.duplicate(
            { projectCode: window.auth.project.UniqueCode, id: ko.unwrap(item.id) },
            {},
            () => {
                TRACK_EVENT('Announcements', 'Duplicated');
                this.reloadAnnouncements();
                this.showToast('The announcement was cloned.');
            }
        );
    }

    localizedTitleOrContent(announcement) {
        const channel = this.getChannelById(ko.unwrap(announcement.channelId));

        if (this.hasSomeTitle(announcement.title)) {
            return ko.unwrap(this.getSomeLocalizedValue(announcement.title));
        } else {
            return ko.unwrap(this.getSomeLocalizedContentPart(announcement.content, true));
        }
    }

    hasSomeTitle(obs) {
        if (obs('en')()) return true;

        for (const lng of window.auth.project.SupportedLanguages) {
            if (obs(lng)()) {
                return true;
            }
        }

        return false;
    }

    getSomeLocalizedValue(obs) {
        if (obs('en')()) return obs('en') || '<i>No title...</i>';

        for (const lng of window.auth.project.SupportedLanguages) {
            if (obs(lng)()) {
                return obs(lng) || '<i>No title...</i>';
            }
        }

        return '<i>No title...</i>';
    }

    getSomeLocalizedContentPart(obs, stripHtml) {
        return ko.pureComputed(() => {
            /** @type {string} */
            let val = ko.unwrap(this.getSomeLocalizedValue(obs)) || '';

            if (stripHtml) {
                const d = document.createElement('div');
                d.innerHTML = val;
                val = d.textContent;
            }

            if (val) {
                if (val.length > 60) {
                    return val.substring(0, 60) + '...'
                } else {
                    return val;
                }
            } else {
                return '<i>No text yet...</i>';
            }
        });
    }
}

export default AnnouncementsOverviewView;